'use client';

import { Color, cx } from '@UI/lib/utils';

interface TrafficLightsProps {
  color: Color;
  maxStrength: number;
  strength: number;
  className?: string;
  label?: string;
}
const TrafficLights: React.FC<TrafficLightsProps> = ({
  color,
  maxStrength,
  strength,
  className,
  label,
}) => {
  const lights = Array.from({ length: maxStrength }, (_, i) => (
    <span
      key={i}
      className={cx(
        'h-4 w-2 rounded-full',
        `${i < strength ? `bg-${color}-500` : 'bg-gray-300 dark:bg-gray-700'}`,
      )}
    />
  ));
  return (
    <span className={cx('flex gap-3 items-center', className)}>
      <span className="flex gap-1">{lights}</span>
      {label && <span className="font-accent text-gray-200">{label}</span>}
    </span>
  );
};

export { TrafficLights, type TrafficLightsProps };
